/* global urlify client */
import $ from "jquery";
// import dayjs from "dayjs";
// import 'dayjs/locale/nb' // load on demand
import { map__singlepoi } from "./map";

import {
    setContactInfo,
    ViewContactByAPI,
    getContactByEmail,
    setContactArticle
} from "./contact_functions";
import { compileResources } from "./compile";
import { skjema_link, skjema_inline } from "./skjema";
import { setImages, setImageText } from "./images";
import { set_accordian } from "./accordian";
import { createGallery } from "./create_gallery";
import { tableResponsive } from "./table";
import language from "./translation";


export const createGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const setVariable = (content, variables) => {

    let regex = /({{link-|{{setting-|{{)([\w]*)(}})/gmi;
    let variablesOnPage = content.match(regex);
    let variablesOnPageLog = content.match(regex) ? content.match(regex).reduce((key, val) => ({ ...key, [val]: "Found"}), {}) : "";

    content = content.replace(/({{link-|{{setting-|{{)([\w]*)(}})/gmi, "$2");

    $.each(variablesOnPage, function() {
        let currVar = (this).replace(/({{link-|{{setting-|{{)([\w]*)(}})/gmi, "$2");
        //variablesOnPageLog[(this)] = "Found";
        if(variables.find(i => i.Key == currVar) == undefined) {
            console.log(`%cVariable "${currVar}" not found`, `font-size: 1rem; color: #001530; background: #a7ceff;`);
            content = content.replace(currVar,`<span class='replace__variable unknown__variable'>${currVar}</span>`);
            variablesOnPageLog[(this)] = "Not found";
        }
    });
    // console.groupCollapsed("Variables used in content...");
    // console.table(variablesOnPageLog)
    // console.groupEnd();

    $.each(variables, function() {
        let vari = $(this)[0],
            re = new RegExp(vari.Key, "g"),
            replaceWith = "";

        if (vari.isRelevantAvailable) {
            if (!vari.isRelevant) {

                replaceWith = `<span class='replace__variable disabled__variable'></span>`;
                content = content.replace(re, replaceWith);
                return;
            }
        }

        if (vari.Value.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gmi)) {
            let name = vari.DisplayName || vari.Value || "";

            let href = ` href="${vari.Value}"`;
            if (vari.Value.match(/^http/gmi)) {
                href = ` href="${vari.Value}" target="_blank"`;
            }

            replaceWith = `<a class="replace__variable replace__variable__link" ${href}>${name}</a>`;
            // console.log(1,replaceWith);
        }
        else if (vari.Value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gmi)) {
            replaceWith = `<a class="replace__variable replace__variable__link replace__variable__link-email" href="mailto:${vari.Value}">${vari.Value}</a>`;
            // console.log(2,replaceWith);
        }
        else if (vari.Value.match(/aim:skjema-inline:/gmi)) {
            let name = vari.DisplayName || vari.Value || "";
            replaceWith = `<div data-skjemaid='${vari.Value.split(":")[1]}' data-skjemanavn="${vari.DisplayName}" id="inline-skjema" class="inlineform__container"></div>`;
            // console.log(3,replaceWith);
            // i++;
        }
        else if (vari.Value.match(/aim:skjema:/gmi)) {
            let name = vari.DisplayName || vari.Value || "";
            // console.log("skjema link", vari);
            replaceWith = `<a class="replace__variable replace__variable__link"  href="${vari.Value}" data-origurl="${vari.Value}">${name}</a>`;
            // console.log(4,replaceWith);
            // i++;
        }
        else if (vari.Value.match(/aim:/gmi)) {
            let name = vari.DisplayName || vari.Value || "";
            replaceWith = `<a class="replace__variable replace__variable__link"  href="${vari.Value}">${name}</a>`;
            // console.log(5,replaceWith);
            // i++;
        }
        else if (vari.Value.match(/skjema:/gmi)) {
            let name = vari.DisplayName || vari.Value || "";
            replaceWith = `<a class="replace__variable replace__variable__link"  href="${vari.Value}">${name}</a>`;
            // console.log(6,replaceWith);
            // i++;
        }
        else if (vari.Value.match(/skjema-inline:/gmi)) {
            // let name = vari.DisplayName || vari.Value || "";
            replaceWith = `<div data-skjemaid='${vari.Value.split(":")[1]}' data-skjemanavn="${vari.DisplayName}" id="inline-skjema" class="inlineform__container"></div>`;
            // console.log(7,replaceWith);
            // i++;
        }
        else {
            replaceWith = `<span class='replace__variable'>${vari.Value}</span>`;
            // console.log(5,replaceWith);
        }
        content = content.replace(re, replaceWith);
    });

    return content;


};

export const setLists = (clientid, content) => {

    content = $(`<class="me">${content}</div>`);
    // console.log(content.find(".content_list").length);

    content.find(".content_list").each(function(obj) {

        const elmId = createGuid();
        const data = $(this).data();
        const start = data.start || 0;

        $(this).attr("id", elmId);
        $(this).html(`<span class='content__wait'>${language("GENERAL_LOADING")} ...</span>`);

        $.getJSON(window.apiUrl + `/api/PublicContentApi/getcontentlist/${clientid}/${data.listtype}/${data.maxnumber}/${start}/${data.orderby}`).done((result) => {

            let elm = [];

            $.each(result.listOfContent, function(a, b) {
                // console.log(`#${elmId}`,$(`#${elmId}`).length);
                elm.push(`
                <div class="listelm">
                    <h3 class="listelm__header">
                        <a href="/article/${b.contentId}" class="listelm__link">${b.title}</a>
                    </h3>
                    <p class="listelm__intro">${b.intro}</p>
                </div>`);
            });

            let r = `<div class='inline-load-list'>${elm.join("")}</div>`;

            $(`#${elmId}`).html(r);

        });
    });


    return content.html();
};

export const removeExtraSpace = function(content) {
    const regex = /<p>&nbsp;<\/p>/gi;

    content = content.replace(regex, "");

    return content;
};

export const checkNested = (obj, level, ...rest) => {
    if (obj === undefined) return false
    if (rest.length == 0 && obj.hasOwnProperty(level)) return true
    return checkNested(obj[level], ...rest)
}

export const getConfig = () => {
    let json = JSON.parse(sessionStorage.getItem("config"));
    return json;
}

export const checkTitles = (content) => {

    let jContent = $(content);

    return content;
}

export const getRelations = (data) => {
    $.each(data, function(nr, relation) {
        $.getJSON(window.apiUrl + "/api/PublicContentApi/find/" + relation.id).done(function(data) {
            if (data.pageTypeId === "mal_visittkort") {
                const meta = data.metaObject || false,
                contact = JSON.parse(decodeURIComponent(meta));
                console.log("contact getRel", contact);

                let mobile = (contact.personMobil.length > 0 ? `<a href="tel:${contact.personMobil}">${contact.personMobil}</a>` : ""),
                    personTelefon = (contact.personTelefon.length > 0 ? `<a href="tel:${contact.personTelefon}">${contact.personTelefon}</a>` : ""),
                    phone = ((mobile != "" || personTelefon != "") ? `<p>Telefon:<br/>${mobile} ${personTelefon}</p>` : ""),
                    title = (contact.personStilling.length > 0 ? `<p>${contact.personStilling}</p>` : ""),
                    department = (contact.personAvdeling.length > 0 ? `<p>${contact.personAvdeling}</p>` : ""),
                    email = (contact.personEpost.length > 0 ? `<p>E-post:<br/> <a href="mailto:${contact.personEpost}" class="text-truncate">${contact.personEpost}</a></p>` : ""),
                    name = (contact.personNavn.length > 0 ? `<h3 class="contact__card__name">${contact.personNavn}</h3>` : ""),
                    text = (contact.personFritekst ? `<p>${contact.personFritekst}</p>` : "");

                $("#unit__relations").append(`
                <div class="article__keyinfo">
                    <h2>Kontakt</h2>
                    <div id="contact_cards">
                        ${name}
                        ${title}
                        ${department}
                        ${phone}
                        ${email}
                        ${text}
                    </div>
                </div>`);
            }
            else if (data.pageTypeId === "mal_enhetsmal") {
                // console.log("Creating enhetsmal?");
                // <h2>Avdeling</h2>
                // console.log("here 2 ?")
                $("#unit__relations").append(`
                <div class="article__keyinfo">
                    <div id="contact_cards">
                        <a href="/artikkel/${data.contentId}">${data.title}</a>
                    </div>
                </div>`);
            }
            else if (data.pageTypeId === "mal_dynamisk") {
                const meta = data.metaObject || false,
                contact = $.parseJSON(decodeURIComponent(meta));
                ViewContactByAPI(contact, "", "", "right");
            }
            else {
                let content = data.contentObject;
                content = decodeURIComponent(content);
                content = compileResources(content, data.relatedContentObjects);
                content = removeExtraSpace(content);
                content = tableResponsive(content).html();
                content = setImages(content);
                // content = setVariable(content, joined);
                content = content.replace(/href\=\"aim:/gim, 'href="/artikkel/');
                content = skjema_link(content);
                // content = setLists(clientid, content);
                content = set_accordian(content);
                // content = checkDocument(content, allRelateds);
                // console.log("test");
                content = content.replace(/h5/gmi, "h6");
                content = content.replace(/h4/gmi, "h5");
                content = content.replace(/h3/gmi, "h4");
                content = content.replace(/h2/gmi, "h3");

                $(".article__content").append(`<div class="externalrelation">
                    <h2>${data.title}</h2>
                    ${content}
                </div>
                `);
                // console.log("external added");
                createGallery();
                // console.log("createGallery added again");
            }
        });
    });

    return `
            <div class="article" id="unit__relations">
            </div>`;
}

export const contentMeta = (metadata) => {

    const meta = metadata.metaObject || metadata || false;

    if (meta !== "undefined") {

        return $.parseJSON(decodeURIComponent(meta));
    }
}

export const getMeta = (metdadata) => {
    return contentMeta(metdadata);
}

export const testDynData = (meta, objname, value) => {

    let r = false;
    if (meta.currentDynamiskMalContent) {
        let result = meta.currentDynamiskMalContent.forEach(obj => {
            //console.log(obj, objname, value, obj[objname] === value);
            if (obj[objname] === value) {
                r = true;
            }
        });
    }

    return r;

}

export const getDynDataOne = (meta, name, objname = "title") => { //// skal skrives ut.


    let result = meta.currentDynamiskMalContent.filter(obj => {

        // console.log("test",urlify(objname),objname, name, obj);

        return obj[objname].match(name) // fjernet urlify
    });

    return result[0];

}

export const getDynData = (meta, selectone = false) => { // erstatter getDynDataOne && testDynData

    let result = {};
    let checks = [];

    meta.currentDynamiskMalContent.forEach(obj => {
        if (obj.title) {
            if (!selectone) {
                result[urlify(obj.title)] = obj.value; // fjernet urlify
                checks.push(true);
            }
            else {
                if (urlify(obj.title) === selectone) {
                    if (obj.value.length > 0) {
                        result.res = obj.value;
                        checks.push(true);
                    }
                }
                else {
                    checks.push(false);
                }
            }
        }
        if (obj.localId) {
            if (!selectone) {
                result[obj.localId] = obj.value;
                checks.push(true);
            }
            else {
                if (obj.localId === selectone) {
                    if (obj.value.length > 0) {
                        result.res = obj.value;
                        checks.push(true);
                    }
                }
                else {
                    checks.push(false);
                }

            }
        }
    });

    // console.log(result, checks);

    if (checks.indexOf(true) >= 0) {
        return result;
    }
    else {
        return { res: false };
    }

}

export const getContent = (id) => {

    let articleUrl = window.apiUrl + "/api/PublicContentApi/find/" + id;
    if (getUrlAttr("showpreview") == "true") {
        articleUrl = window.apiUrl + "/api/PublicContentApi/find/" + id + "/preview";
    }

    return $.getJSON(articleUrl)
}

export const UpdateQueryString = (key, value) => {
    const params = new parent.URLSearchParams(parent.location.search);
    if (params.has(key)) {
        params.set(key, value);
    }
    else {
        params.append(key, value);
    }

    if (window.history.pushState) {
        const newURL = new URL(window.location.href);
        newURL.search = '?' + params.toString();
        window.history.pushState({ path: newURL.href }, '', newURL.href);
    }

    //return "?" + params.toString();
}

export const getRelatedBlocks = (article, type) => {
    let contacts = [];
    let blocks = [];
    let units = [];

    if (article.relatedSubscriberContents) {
        if (article.relatedSubscriberContents.length > 0) {
            const rel = contentMeta(article.relatedSubscriberContents);
            // console.log("rel laster relasjoner")
            rel.forEach((related_content) => {
                // console.log("alle",related_content);

                if (related_content.type === "mal_visittkort") {
                    related_content.relations.forEach((contact) => {
                        contacts.push({ id: contact.contentId });
                    });
                }
                else if (related_content.type === "mal_blokk") {
                    related_content.relations.forEach((block) => {
                        blocks.push({ id: block.contentId });
                    });
                }
                else if (related_content.type === "mal_enhetsmal") {
                    related_content.relations.forEach((block) => {
                        units.push({ id: block.contentId });
                    });
                }
            });
        }
    }

    // if(article.re)
    if (type === "block") {
        // console.log("BLOcKS",blocks);
        return blocks;
    }
    else if (type === "contact") {
        return contacts;
    }
    else if (type === "unit") {
        return units;
    }
}

export const adjustVariables = (variables) => {

    let lang = client.lang || "nb";

    variables.forEach(item => {

        // console.log(item);

        item.Key = item.key;
        if (item.languages) {
            let itemLang = item.languages.find(obj => {return obj.cultureNameShort.startsWith(lang)});
            itemLang = itemLang!=undefined?itemLang:item.languages[0];
            if (item.languages.length > 0) {
                item.DisplayName = itemLang.displayName;

                if (itemLang.value) {
                    item.Value = itemLang.value
                }
                else {
                    item.Value = "";
                }
            }

        }
    });

    return variables;
}

export const urlParseCheck = (content) => {

    // console.log("run urlParseCheck");

    // let clientname = client.skjema ? client.skjema.id : client.nameId; 

    // let defaultformlink = ;
    // let bypass = "https://skjema.no/" + clientname;

    let formlink = "/skjema/";

    if (client.skjema) {
        // console.log("hasconfig");
        if (client.skjema.url) {

            // console.log("har url", client.skjema);
            formlink = client.skjema.url;
        }
    }
    // console.log("skjemalenke", formlink, client);

    if (content.match(/aim:skjema:/gmi)) {
        content = content.replace(/aim:skjema:/gmi, formlink);
    }
    else if (content.match(/aim:/gmi)) {
        content = content.replace(/aim:/gmi, "/artikkel/");
    }
    else if (content.match(/skjema:/gmi)) {
        content = content.replace(/skjema:/gmi, formlink);
    }
    else if (content.match(/skjema_inline:/gmi)) {
        content = content.replace(/aim:skjema:/gmi, formlink);
    }
    // alert("test")

    return content;
}

export const checkDocument = (content, related) => {
    // console.log("go", related);
    let parse = $("<div class='article-parse'>" + content + "</div>");
    
    parse.find(".documentBlokk").each(function() {
        // console.log("checking ", $(this).html());
        let id = $(this).attr("href");
        // console.log("lenght documentblock", parse.find(".documentBlokk").length, related, id);
        let doclink = $(this);
        $.each(related, function(nr, obj) {
            // console.log("each related0",obj, id)
            if (id === obj.contentId) {
                doclink.attr("href", obj.path).attr("target", "_blank");
            }
        });
    });
    return parse.html();
}

export const getObject = (id, cb) => {
    $.getJSON(window.apiUrl + "/api/PublicContentApi/find/" + id).done(function(data) {

        cb(data);

    });
}

export const extendArticle = (article) => {

    // console.log(article);
    if (article.metaObject) {
        //  console.log("has meta");
        article.metaParsed = JSON.parse(decodeURIComponent(article.metaObject));
        if (article.metaParsed.currentDynamiskMalContent && article.metaParsed.currentDynamiskMalContent.length > 0) {
            article.metaDynamic = {};
            article.metaParsed.currentDynamiskMalContent.forEach(cmc => {
                article.metaDynamic[cmc.title] = cmc.value;
            })
        }
    }

    return article;
}

export const articlesExtend = (article) => {

    // console.log(article.metaObject, article.metaObject !== "mermeta");
    if (article.metaObject && article.metaObject !== "mermeta" && article.metaObject !== "undefined" && typeof article.metaObject !== "undefined") {
        //  console.log("has meta");
        article.metaParsed = JSON.parse(decodeURIComponent(article.metaObject));
        if (article.metaParsed.currentDynamiskMalContent && article.metaParsed.currentDynamiskMalContent.length) {
            // console.log("okey")
            article.metaDynamic = {};
            article.metaParsed.currentDynamiskMalContent.forEach(cmc => {
                article.metaDynamic[cmc.title] = cmc.value;
            })
        }
    }

    return article;
}

export const setCorrectTemplate = (metaParsed) => {

    metaParsed.contentTypeId = metaParsed.contentTypeId === undefined ? metaParsed.id : metaParsed.contentTypeId;

    if (metaParsed.contentTypeId === "dd8d6460-5242-404f-a8dc-c75533bd06bd") {
        return "minside";
    }
    else if (metaParsed.contentTypeId === "1bb71f41-4ee6-4394-b78f-3202e2f5eeda") {
        return "transportside";
    }
    else if (metaParsed.contentTypeId === "882f5a94-f859-49d3-b3c8-50a7c70d0f1b") {
        return "forside";
    }
    else if (metaParsed.contentTypeId === "fd54728e-1956-433b-a33b-a7f95023dd37") {
        return "fokusartikkel";
    }
    else if (metaParsed.contentTypeId === "5353f0bd-a7d5-42aa-aca2-ae17fe447f2f") {
        return "bti-forside";
    }
    else {
        return false
    }

}

export const urlRest = (url) => {

    console.log("rest",url, window.location.hash, window.location.search);
    
    return window.location.search + "" + window.location.hash;
    
}